
import { defineComponent } from 'vue';
import HomeVideo from '@/components/home/Video.vue'
import HomeMap from '@/components/home/Map.vue'
import HomeFacebook from '@/components/home/Facebook.vue'

export default defineComponent({
  name: 'Home',
  components: {
    HomeVideo,
    HomeMap,
    HomeFacebook
  }
});
